import axios from './BaseService';

const API_URL = process.env.REACT_APP_API_URL;

export async function getTelegramUsers() {
    const url = `${API_URL}/telegram-news/users`;
    const response = await axios.get(url);
    return response.data;
}

export async function sendTelegramNews({ sendToAll, userId, message }) {
    const url = `${API_URL}/telegram-news/send`;
    const response = await axios.post(url, { sendToAll, userId, message });
    return response.data;
}




